import { Badge } from './Badge.jsx';
import { labelForSeverity } from '../utils/severity.js';

/**
 * Severity pill used on category rows, check headers, and Fix Queue rows.
 * Renders the uppercase label (CRITICAL / WARNING / LOW / PASS) in the
 * color matching its severity — identical to PDF coloring for coherence.
 */
export function SeverityBadge({ severity, size = 'md' }) {
  const label = labelForSeverity(severity);
  return (
    <Badge variant={severity} size={size}>
      {label}
    </Badge>
  );
}
